// extracted by mini-css-extract-plugin
export default {"cls1":"FundingList-AlignEnd_cls1__eeq8l","cls2":"FundingList-AlignEnd_cls2__GnQLe FundingList-AlignEnd_cls1__eeq8l"};